import { motion } from 'framer-motion';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FAQSectionData } from '../../types/faq';
import { H2, H4, Body } from '../ui/Typography';

interface FAQSectionProps {
  section: FAQSectionData;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQSection({ section, isOpen, onToggle }: FAQSectionProps) {
  return (
    <div className={`bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 ${
      isOpen ? 'opacity-100' : 'opacity-50'
    }`}>
      <button
        onClick={onToggle}
        className="w-full px-8 py-6 flex justify-between items-center hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center">
          <section.icon className="w-6 h-6 text-secondary mr-3" />
          <H2 className="text-primary">{section.title}</H2>
        </div>
        <ChevronDownIcon
          className={`w-6 h-6 text-primary transition-transform ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>
      
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.3 }}
          className="px-8 pb-6"
        >
          <div className="space-y-6">
            {section.questions.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-gray-50 rounded-lg p-6"
              >
                <H4 className="text-gray-900 mb-3">{faq.question}</H4>
                <Body className="text-gray-600">{faq.answer}</Body>
              </motion.div>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
}